









import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'
import activeInfoPage from '@/components/Ui/ActiveInfoPage/ActiveInfoPage.vue'
import config from '@/activePages/resp/page'
import Resp from '@/models/resp/Resp'
import {E_NOT_FOUND, E_STATUS} from '@/constants'
import WarnPage from '@/components/WarnPage/WarnPage.vue'

export default Vue.extend({
  props: {
    id: String
  },
  data () {
    return {
      config,
      loaded: false,
      noAccess: false,
      noAccessMessage: ''
    }
  },
  components: {
    activeInfoPage,
    WarnPage
  },
  methods: {
    async loadResp () {
      try {
        await store.dispatch('resp/get', this.id)
        this.loaded = true
        // @ts-ignore
        this.$bus.$emit('pathChanged')
      } catch (error) {
        console.error('LOG: loadResp -> error', error)
        if (error.data.error.code === E_NOT_FOUND) {
          // @ts-ignore
          this.noAccessMessage = this.$t('polls.poll_not_found')
          this.noAccess = true
        } else if (error.data.error.code === E_STATUS) {
          // @ts-ignore
          this.noAccessMessage = this.$t('polls.no_permissions_for_poll')
          this.noAccess = true
        } else {
          // @ts-ignore
          this.$message.error(this.$t('polls.unknown_error_load_poll'))
        }
      }
    }
  },
  computed: {
    resp (): Resp {
      return this.$store.state.resp.resps[this.id]
    }
  },
  async mounted () {
    await this.loadResp()
  }
})
